const videos = document.querySelectorAll('.video-attachment')

if(videos && videos.length) {
  videos.forEach((el) => {
    const link = el.querySelector('[href*="#"]')
    link.addEventListener('click', attachVideo)
  })

  function attachVideo(e) {
    e.preventDefault()
    const iFrameUrl = e.target.dataset.video
    const consentContainer = document.createElement('div')
    consentContainer.className = 'absolute w-full'
    const mainParent = e.target.parentNode.parentNode
    const videoContainer = e.target.parentNode
    e.target.parentNode.classList.remove('external-video__container--no-consent')
    e.target.parentNode.classList.add('ask-for-consent')
    const consentApproval = mainParent.querySelector('.consent')
    consentApproval.classList.add('flex')
    consentApproval.addEventListener('click', (e) => {
      console.log(e.target)
      const iframe = document.createElement("iframe");
      iframe.setAttribute("src", iFrameUrl+ '&autoplay=1&rel=0');
      iframe.setAttribute('allow', 'autoplay')
      console.log(iframe)
      videoContainer.appendChild(iframe)
      consentApproval.remove()
    })
    consentApproval.classList.remove('hidden')

  }
}
